// extracted by mini-css-extract-plugin
export default {"actions":"agents-list-item_actions__GomgS","name":"agents-list-item_name__Kk9Iw"};